import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import React from 'react';
import ContentHeader from '~components/content-header';
import Typography from '~components/typography';
import { PicSpaceman } from '~svg-components';

const useStyles = makeStyles((theme) => ({
  root: {
    height: 'calc(80vh - 80px)',
    minHeight: 300,
  },

  content: {
    ...theme.flex.col,
    ...theme.flex.center,
    height: '100%',
  },

  pic: {
    width: 176,
    height: 176,
  },

  message: {
    marginTop: 32,
  },
}));

function ErrorContainer({ children, description }) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <ContentHeader showPropertySelection={false} showAcademicYearTab={false} />
      <div className={classes.content}>
        <PicSpaceman className={classes.pic} />
        <Typography variant="h3" themeColor="dark" className={classes.message}>
          {description}
        </Typography>
        {children}
      </div>
    </div>
  );
}

ErrorContainer.propTypes = {
  description: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

ErrorContainer.defaultProps = {};

export default ErrorContainer;
